'use client';

import { ReactNode, createContext, useContext, useEffect } from 'react';

import { useTracker } from '@r123/segment-tracker';

import { ListingTrackerProps } from '@/app/_tracker/segment/getListingTrackerProps';

const ListingTrackerContext = createContext<ListingTrackerContext>({
    listingTrackerData: undefined,
});

export function SegmentTrackerProvider({
    trackerData,
    isRepost,
    children,
}: ListingTrackerProviderProps) {
    const { sendPageTracker } = useTracker();
    useEffect(() => {
        if (typeof window !== 'undefined') {
            sendPageTracker(
                'LDP Page Visited',
                'LDP Page Visited',
                trackerData,
                {},
            );
        }
    }, []);

    const context: ListingTrackerContext = {
        listingTrackerData: trackerData,
        isRepost,
    };

    return (
        <ListingTrackerContext.Provider value={context}>
            {children}
        </ListingTrackerContext.Provider>
    );
}

export function useListingTracker(): ListingTrackerContext {
    return useContext(ListingTrackerContext);
}

type ListingTrackerContext = {
    listingTrackerData?: ListingTrackerProps;
    isRepost?: boolean;
};

type ListingTrackerProviderProps = {
    trackerData: ListingTrackerProps;
    isRepost?: boolean;
    children: ReactNode;
};
